<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <el-container style="height: 650px">
            <el-header style="line-height: 60px">
                <el-row type="flex" :gutter="20" justify="start">
                    <el-col>
                        <el-button class="btn-primary" size="small" v-if="permission.del" @click="delEntpApplyTypes">{{ permission.del }}</el-button>
                        <el-button style="margin-right: 10px" class="btn-primary" size="small" v-if="permission.add" @click="showEditDialog">{{ permission.add }}</el-button>
                        <el-input style="width: 300px; margin-right: 10px" v-model="searchData.name" placeholder="关键字查找"></el-input>
                        <el-button class="btn-primary" size="small" @click="getEntpApplyTypesList">搜索</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-container style="height: 100%">
                <el-main width="100%" height="100%" style="padding-top: 0px">
                    <el-table @selection-change="handleSelectionChange" :header-cell-style="{ background: '#F2F6FC' }" :data="entpApplyTypesList" border style="width: 100%" fit>
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="Name" label="类型名称"></el-table-column>
                        <el-table-column prop="DeviceName" label="是否默认">
                            <template slot-scope="scope">
                                <span>{{ getIsDefault(scope) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <div class="ops-ctn">
                                    <el-button type="text" size="mini" v-if="permission.edit" @click="showEditDialog(scope)">{{ permission.edit }}</el-button>
                                    <el-button type="text" size="mini" v-if="permission.del" @click="delEntpApplyTypes(scope)">{{ permission.del }}</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
                <div class="pagination-ctn">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchData.page"
                        :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                        :page-size="searchData.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="dataCount"
                    ></el-pagination>
                </div>
                <el-dialog :title="titleName" :visible.sync="edit_dialogVisible" width="400px">
                    <el-form :rules="rules" :model="editEntpApplyTypeData" style="padding-top: 25px">
                        <el-row>
                            <el-form-item label="类型名称" prop="name">
                                <el-input style="width: 280px" v-model="editEntpApplyTypeData.name" placeholder="申请类型名称"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row type="flex" justify="end" style="margin-bottom: 15px">
                            <el-button size="small" class="btn-primary" @click="edit_dialogVisible = false">取消</el-button>
                            <el-button size="small" class="btn-primary" @click="editEntpApplyType">提交</el-button>
                        </el-row>
                    </el-form>
                </el-dialog>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            titleName: '',
            dataCount: 0,
            edit_dialogVisible: false,
            ids: '',
            permission: this.$util.getPermission('ApplyType'),
            searchData: {
                entpId: userMsg.EntpId,
                name: '',
                page: 1,
                limit: 15
            },
            editEntpApplyTypeData: {
                id: '',
                entpId: userMsg.EntpId,
                name: ''
            },
            entpApplyTypesList: [],
            getIsDefault(scope) {
                return scope.row.IsDefault == true ? '是' : '否';
            },
            rules: {
                name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getEntpApplyTypesList();
    },
    mounted() {},
    methods: {
        showEditDialog(scope) {
            if (scope.row) {
                this.titleName = '修改申请类型';
                this.editEntpApplyTypeData.id = scope.row.Id;
                this.editEntpApplyTypeData.name = scope.row.Name;
            } else {
                this.titleName = '新增申请类型';
                this.editEntpApplyTypeData.id = '';
                this.editEntpApplyTypeData.name = '';
            }
            this.edit_dialogVisible = true;
        },
        //获取企业类型
        getEntpApplyTypesList() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetEntpApplyTypesList',
                    data: this.searchData
                })
                .then(res => {
                    this.dataCount = res.count;
                    if (res.data) {
                        this.entpApplyTypesList = res.data;
                    }
                })
                .catch(err => {});
        },
        //编辑企业类型
        editEntpApplyType() {
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/EditEntpApplyType',
                    data: this.editEntpApplyTypeData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg('更新成功');
                        this.edit_dialogVisible = false;
                        this.getEntpApplyTypesList();
                    }
                })
                .catch(err => {});
        },
        delEntpApplyTypes(scope) {
            let id = '';
            if (scope.row) {
                id = scope.row.Id;
            } else {
                id = this.ids;
            }
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/DelEntpApplyTypes?ids=' + id
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg('删除成功');
                        this.getEntpApplyTypesList();
                    }
                })
                .catch(err => {});
        },
        handleSelectionChange(val) {
            this.ids = '';
            val.forEach(element => {
                this.ids += element.Id + ',';
            });
            this.ids = this.ids.slice(0, this.ids.length - 1);
        },
        // 分页处理
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getEntpApplyTypesList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getEntpApplyTypesList();
        }
    }
};
</script>
<style lang="less" scoped></style>
